module.exports = __webpack_public_path__ + "static/img/1050.3efb648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/1050.png
// module id = 5/6a
// module chunks = 0